import { render, staticRenderFns } from "./Autumn.vue?vue&type=template&id=0a7da414&"
import script from "./Autumn.vue?vue&type=script&lang=js&"
export * from "./Autumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports